import {
  TablePageLayout,
  DataTableExRef,
  NotificationsContext,
} from '@kirz/mui-admin';
import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Stack, Typography } from '@mui/material';
import React, { useContext, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { DirectoriesTable } from 'components/DirectoriesTable';
import { DocumentsTable } from 'components/DocumentsTable';
import { UserContext } from 'contexts/UserContext';
import { useSettings } from 'hooks/useSettings';
import { HideStationSelector } from 'layouts/HideStationSelector';
import { Client, User } from 'types/user';

export function Documents() {
  const params = useParams();
  const { showAlert } = useContext(NotificationsContext);
  const { user } = useContext(UserContext);
  const { directories } = useSettings();
  const directory = directories.find((x) => x?.id === Number(params.id));
  const client = user as Client;
  const generatedEmail =
    directory?.emailAccountSuffix &&
    client.emailAccounts[directory.emailAccountSuffix].email;

  const tableRef = useRef<DataTableExRef>(null);

  if (!directories?.length || !directory) {
    return <h3>Directory not found</h3>;
  }

  return (
    <HideStationSelector>
      <TablePageLayout
        title={directory?.formattedName}
        actionContent={
          <Stack direction="row" alignItems="center" spacing={2} sx={{ ml: 3 }}>
            <Button
              sx={{ ml: 5, lineHeight: 1 }}
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => {
                tableRef.current?.openFormDialog();
              }}
            >
              Document(en) uploaden
            </Button>
            {generatedEmail && (
              <Typography variant="body2" sx={{ lineHeight: 1.1 }}>
                Je kan deze documenten ook via e-mail doorsturen:
                <br />
                <Box
                  component="a"
                  onClick={() => {
                    navigator.clipboard.writeText(generatedEmail);
                    showAlert('Gekopieerd naar klembord', 'success');
                  }}
                  sx={(theme) => ({
                    color: theme.palette.primary.main,
                    textDecoration: 'underline',
                  })}
                >
                  {generatedEmail}
                </Box>
              </Typography>
            )}
          </Stack>
        }
      >
        <DocumentsTable
          id="documents-table"
          attachmentType={directory.name}
          ref={tableRef}
          // deletable={false}
          searchFilter={{
            inputProps: {
              placeholder: 'Zoeken op naam',
            },
            filter: (search) => ({
              _or: search.flatMap((str) => [{ name: { _ilike: `%${str}%` } }]),
            }),
          }}
        />
      </TablePageLayout>
    </HideStationSelector>
  );
}
